import { createClient } from "@insforge/sdk";

// `.trim()` tolerates accidental trailing whitespace / newlines in the
// Vercel env var UI — a single stray "\n" at the end of baseUrl otherwise
// produces malformed URLs like `https://host\n/auth/...` and makes every
// request fail silently.
const insforgeUrl = (process.env.REACT_APP_INSFORGE_URL || "").trim();
const insforgeAnonKey = (process.env.REACT_APP_INSFORGE_ANON_KEY || "").trim();

// Fail loud (never throw — this module is imported at app boot) when the
// two env vars weren't inlined at build time. Without them CRA leaves the
// references as `undefined`, the SDK silently falls back to its default
// `http://localhost:7130`, and every call fails with a generic
// "Failed to fetch" from the browser. See docs/ENVIRONMENTS.md.
if (!insforgeUrl || !insforgeAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    "[pikra] InsForge env vars missing at build time. Set " +
      "REACT_APP_INSFORGE_URL and REACT_APP_INSFORGE_ANON_KEY for the " +
      "current Vercel environment (Production AND Preview), then redeploy " +
      "without build cache."
  );
}

export const insforge = createClient({
  baseUrl: insforgeUrl,
  anonKey: insforgeAnonKey,
});

// Exported for `backend/functions.js`, which builds edge-function requests
// itself instead of using `insforge.functions.invoke()`. See the note there.
export const INSFORGE_URL = insforgeUrl;
export const INSFORGE_ANON_KEY = insforgeAnonKey;

/**
 * Environment isolation flag. When `true`, every DB row written through
 * `fromTable()` is tagged `is_staging=true`, and every read is filtered to
 * the same. See docs/ENVIRONMENTS.md.
 *
 * Set `REACT_APP_IS_STAGING="true"` on Vercel Preview + Development scopes;
 * leave unset (or "false") on Production.
 *
 * Exposed as a function so the manual mock in `__mocks__/insforge.js` can
 * return a mutable value during tests; the named constant below is a snapshot
 * at module-load for code paths that don't care about mocking.
 */
export function getIsStaging() {
  return (process.env.REACT_APP_IS_STAGING || "").trim() === "true";
}

export const IS_STAGING = getIsStaging();
